    var thumbs_num = $(".keyvisual_thumbs .swiper-slide").length
    var thumbsSwiper = new Swiper(".keyvisual_thumbs", {
        slidesPerView: thumbs_num,
        freeMode: true,
        watchSlidesProgress: true,
        // 23.01.10 추가
        on: {
                touchEnd: function(s,e) {
                    let range = thumbs_num;
                    let diff = s.touches.diff = s.isHorizontal() ? s.touches.currentX - s.touches.startX : s.touches.currentY 
                                - s.touches.startY
                    if (diff < range || diff > -range) s.allowClick = true;
                }
        }
    });
    var keyvisualSwiper = new Swiper(".keyvisual-swiper", {
        slideActiveClass:'active',
        effect:'fade',
        speed:500,
        fadeEffect: {
            crossFade: true
        },
        thumbs: {
            swiper:thumbsSwiper,
        },
        on:{
            // 230104 수정
            activeIndexChange:function(){
                var num = this.activeIndex;
                if(this.slides[num].classList.contains('dark') === true) {
                    $(".pdp_keyvisual").addClass("dark")
                }else{
                    $(".pdp_keyvisual").removeClass("dark")
                }
                // * 23.01.16
                if(this.slides[num].classList.contains('video') === true) {
                    var video = this.slides[num].getElementsByTagName('video')[0]
                    video.currentTime = 0
                    video.play();
                }else {
                    var video = $(".keyvisual-swiper .swiper-slide.video").find('video');
                    video.each(function(){
                        if(!$(this).paused) {
                            video.get(0).currentTime = 0
                            video.get(0).pause();
                        }
                    })
                }
                // 23.01.16 *
                // $(".option button:nth-child("+(num+1)+")").addClass("active").siblings().removeClass("active")
        }
    },
});

$(".option button").on("click", function(){
    $(".pdp_keyvisual").removeClass("dark")
    $(this).addClass("active")
    $(this).siblings().removeClass("active")
})

var key = {
    option:function(number) {
        keyvisualSwiper.slideTo(number, 400, false)
    },
}

$(".accordion-action .title").click(function(){
    var item = $(this).closest("li")
    if($(item).hasClass("active")){
        $(item).removeClass("active");
        $(item).children(".screen").slideUp(400).scrollTop(0)
    } else {
        $(item).addClass("active");
        $(item).children(".screen").slideDown(400)
        $(item).siblings().removeClass("active");
        $(item).siblings().children(".screen").slideUp(400).scrollTop(0)
    }
});

// colorchip 관련 이벤트
const setColorChip = {
    chipTarget: '.color-chip',
    chipButton: '.color-chip__box',
    chipText: '.selected-chip',
    init() {
        // colorchip 요소 있을 시 실행
        document.querySelector(this.chipTarget) && this.eventColorChip();
    },
    eventColorChip() {
        // 칩 요소들에 이벤트 바인딩
        const chipArray = document.querySelectorAll(`${this.chipTarget} ${this.chipButton}`);
        const textTarget = document.querySelector(`${this.chipTarget} ${this.chipText}`);

        this.chipTextResult(textTarget);

        chipArray.forEach((t, i) => {
            t.addEventListener('click', event => this.chipEvent(event.target));
        })
    },
    chipTextResult(text) {
        // 컬러칩명 규칙에서 공백기준 분리하여 span감싸기
        const textTarget = document.querySelector(`${this.chipTarget} ${this.chipText}`);
        const textResult = text.innerText.split(' ');
        const resultText = '';
        textResult[0] = `<span>${textResult[0]}</span>`;

        textTarget.innerHTML = textResult.join(' ');
    },
    chipEvent(target) {
        // 컬러칩 실제 이벤트
        const targetArray = document.querySelectorAll('.pdp_keyvisual .swiper-wrapper');
        const thumbArray = target.dataset['image'].trim().split(',');
        const chipArray = document.querySelectorAll(`${this.chipTarget} ${this.chipButton}`);
        const selectedClass = `${this.chipButton.replace('.', '')}--selected`
        const swiperLength = targetArray[0].querySelectorAll('.swiper-slide').length;

        if(swiperLength > 1) {
            const lastSlideIndex = swiperLength - 1;
            keyvisualSwiper.slideTo(lastSlideIndex - 1, 400, false);
        }

        chipArray.forEach((t, i) => {
            t.classList.remove(selectedClass);
        });
        target.classList.add(selectedClass);
        this.chipTextResult(target)

        targetArray.forEach(t => {
            const target = t.querySelectorAll('.swiper-slide');
            const chipDefaultIndex = target.length - thumbArray.length;
            thumbArray.forEach((url, i) => {
                target[chipDefaultIndex + i].querySelector('img').src = url;
            });
        });
        
    }
}

$(function(){
    setColorChip.init(); // 240912 컬러칩세팅 추가
    
    var progressIndicator = "<div class='progress_indicator'></div>";
    // $("body").append(progressIndicator);
    $("#header").append(progressIndicator);
    $(window).on("scroll", function(){
        var currentPercentage = ($(window).scrollTop() / ($(document).outerHeight() - $(window).height())) * 100;
        $(".progress_indicator").width(currentPercentage+"%");
    });

    // document.querySelector('.option button.active')?.click();
    
})

function changeSwiper(image){
    key.option(findDataNumByImageSrc(image))
}

function findDataNumByImageSrc(imageUrl) {
  // 모든 'swiper-slide' 클래스를 가진 div 요소를 가져옵니다.
  const swiperSlides = document.querySelectorAll('.keyvisual-swiper .swiper-slide');

  // 각 swiper-slide를 반복하며 이미지를 찾습니다.
  for (const slide of swiperSlides) {
    const imgElement = slide.querySelector('img'); // 현재 슬라이드 안의 img 태그를 찾습니다.

    // img 태그가 존재하고, src 속성이 일치하는지 확인합니다.
    if (imgElement && imgElement.src.includes(imageUrl)) {
      // 일치하는 경우, 해당 swiper-slide의 data-num 속성 값을 반환합니다.
      return slide.dataset.num; // dataset.num은 data-num 속성에 접근하는 표준 방식입니다.
    }
  }

  // 일치하는 이미지를 찾지 못한 경우 null을 반환합니다.
  return null;
}

function changeOptionActive(selectedVariantId){
    
    const optionButtons = document.querySelectorAll('.option > button[data-variant-id]');

    optionButtons.forEach(button => {
      const buttonVariantId = button.dataset.variantId; // 'data-variant-id' 값을 문자열로 가져옵니다.

      if (buttonVariantId === selectedVariantId) {
        button.classList.add('active'); // ID가 일치하면 'active' 클래스 추가
      } else {
        button.classList.remove('active'); // ID가 일치하지 않으면 'active' 클래스 제거
      }
    });
}
